/**
 * @generated SignedSource<<d85973ee99c170e6eee7d64e57ebeb2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerDetailsHeader_user$data = {
  readonly canShowSellerName: boolean | null;
  readonly " $fragmentType": "PdpSharedSellerDetailsHeader_user";
};
export type PdpSharedSellerDetailsHeader_user$key = {
  readonly " $data"?: PdpSharedSellerDetailsHeader_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerDetailsHeader_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerDetailsHeader_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "520d4977a19df1c16de1d4a0f7a37698";

export default node;
